import { render, staticRenderFns } from "./SupervisionTemplate.vue?vue&type=template&id=49a5d0a2&scoped=true&"
import script from "./SupervisionTemplate.vue?vue&type=script&lang=js&"
export * from "./SupervisionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionTemplate.vue?vue&type=style&index=0&id=49a5d0a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5d0a2",
  null
  
)

export default component.exports